import React from "react";
import HomeBanner from "./Component/HomeBanner/HomeBanner";
import Nav from "./Component/ NavBar/Nav";
import Services from "./Component/Services/Services";
import HomeAbout from "./Component/HomeAbout/HomeAbout";
import Packages from "./Component/Packages/Packages";
import Footer from "./Component/Footer/Footer";

const App = () => {
  return (
    <div>
      <Nav />
      <HomeBanner />
      <Services />
      <HomeAbout />
      <Packages />
      {/* <Footer /> */}
    </div>
  );
};

export default App;
